import type { ColumnsType } from 'antd/es/table';
import { useMemo } from 'react';

import type { DayOfWeek } from 'app/typings/core/common/enum/dayOfWeek';

import type { RowData } from '../types';

import { useDayColumns } from './useDayColumns';
import { useLeadingColumns } from './useLeadingColumns';

export const usePriceColumns = (
  days: DayOfWeek[],
  hasDayPrice: boolean,
  hasAdultChildPrice: boolean,
  dataSource: RowData[]
): ColumnsType<RowData> => {
  const leadingColumns = useLeadingColumns(
    hasDayPrice,
    hasAdultChildPrice,
    dataSource
  );
  const dayColumns = useDayColumns(days);

  return useMemo(
    () => [...leadingColumns, ...dayColumns],
    [leadingColumns, dayColumns]
  );
};
